import { Fragment } from "react";
import { Link } from "react-router-dom";
import CheckboxActiveIcon from "src/components/ui-icons/myTasks/CheckboxActiveIcon";
import Audit5SIcon from "src/components/ui-icons/menu/myTasks/5sAudit";
import CogSearchIcon from "src/components/ui-icons/myTasks/CogSearchIcon";
import HelpIcon from "src/components/ui-icons/myTasks/HelpIcon";
import ListIcon from "src/components/ui-icons/myTasks/ListIcon";
import Shield3Icon from "src/components/ui-icons/myTasks/Shield3Icon";
import WarningIcon from "src/components/ui-icons/myTasks/WarningIcon";
import { ReportIcon } from "src/components/ui-icons/sidebar";
import { useAppSelector } from "src/hooks/redux";
import { selectCurrentUser } from "src/modules/users/selector";

const reportPagePath = "/dashboard/3/reports";

const reportsList = [
  {
    title: "Отчет по действиям",
    icon: <ListIcon />,
    description: "Посмотреть отчет",
    path: `${reportPagePath}/1`,
  },
  {
    title: "Отчет по 5Почему",
    icon: <HelpIcon />,
    description: "Посмотреть отчет",
    path: `${reportPagePath}/2`,
  },
  {
    title: "Отчет по отклонениям",
    icon: <CogSearchIcon />,
    description: "Посмотреть отчет",
    path: `${reportPagePath}/3`,
  },
  {
    title: "Отчет по инцидентам",
    icon: <WarningIcon />,
    description: "Посмотреть отчет",
    path: `${reportPagePath}/4`,
  },
  {
    title: "Отчет по инцидентам. Отправить по почте",
    icon: <WarningIcon />,
    key: "incReportFromEmail",
    description: "Отправить по почте",
    path: `${reportPagePath}/6`,
  },
  {
    title: "Матрица SDCA",
    icon: <Shield3Icon />,
    description: "Посмотреть отчет",
    path: `${reportPagePath}/5`,
  },
  // {
  //   title: "Отчет по 5S аудитам",
  //   icon: <Audit5SIcon />,
  //   description: "Посмотреть отчет",
  //   path: `${reportPagePath}/7`,
  // },
  // {
  //   title: "Выполнение графика аудитов 5S",
  //   icon: <Audit5SIcon />,
  //   description: "Посмотреть отчет",
  //   path: `${reportPagePath}/8`,
  // },
  // {
  //   title: "Отчет по задачам чек-листов",
  //   icon: <CheckboxActiveIcon />,
  //   description: "Посмотреть отчет",
  //   path: `${reportPagePath}/7`,
  // },
  {
    title: "Отчет по 5S аудитам",
    icon: <Audit5SIcon width={24} height={24} color="currentColor" />,
    description: "Посмотреть отчет",
    path: `${reportPagePath}/7`,
  },
  {
    title: "Выполнение графика аудитов 5S",
    icon: <Audit5SIcon width={24} height={24} color="currentColor" />,
    description: "Посмотреть отчет",
    path: `${reportPagePath}/8`,
  }
];

export default function MyTaskReportsPage() {
  const currentUser: any = useAppSelector((state) => selectCurrentUser(state));
  return (
    <>
      <div className="px-7.5 py-[26px] border-b border-[#DFE4EA]-500">
        <div className="flex gap-2 items-center hover:cursor-pointer w-fit">
          <span>
            <ReportIcon />
          </span>
          <span>Отчеты</span>
        </div>
      </div>
      <div className="grid grid-cols-3 py-5 px-7.5 gap-5">
        {reportsList.map((report) => (
          <Fragment key={report.path}>
            {((report.key && report.key === "incReportFromEmail" && currentUser.id && (currentUser.incidentAdmin || currentUser.isAdmin)) && (
              <div key={report.path}>
                <Link
                  to={report.path}
                  title={report.description}
                  className="group bg-white shadow-custom py-[60px] flex rounded-md justify-center gap-2 font-medium hover:text-darkblue"
                >
                  <div className="group-hover:text-darkblue">{report.icon}</div>
                  <div className="text-center group-hover:text-darkblue">{report.title}</div>
                </Link>
              </div>
            )) ||
              (!report.key && (
                <div key={report.path}>
                  <Link
                    to={report.path}
                    title={report.description}
                    className="group bg-white shadow-custom py-[60px] flex rounded-md justify-center gap-2 font-medium hover:text-darkblue"
                  >
                    <div className="group-hover:text-darkblue">{report.icon}</div>
                    <div className="text-center group-hover:text-darkblue">{report.title}</div>
                  </Link>
                </div>
              ))}
          </Fragment>
        ))}
      </div>
    </>
  );
}
